import { EnumDropdown } from 'framework/form';

const StatusDropdown = ({ dropdownLabel = 'Status', ...props }: any) => {
  return <EnumDropdown {...props} label={dropdownLabel} placeholder="Choose Project Status" />;
};

export default StatusDropdown;
